import { render, staticRenderFns } from "./VsTableRow.vue?vue&type=template&id=56f8a1aa&scoped=true&"
import script from "./VsTableRow.vue?vue&type=script&lang=js&"
export * from "./VsTableRow.vue?vue&type=script&lang=js&"
import style0 from "./VsTableRow.vue?vue&type=style&index=0&id=56f8a1aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f8a1aa",
  null
  
)

export default component.exports